import React, { useState, useEffect } from 'react';
import './../../styles/principals/services.css'; // Estilos CSS para el componente
import axios from 'axios';
import { Link } from "react-router-dom";

const Services = () => {
  const [services, setServices] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [serviceImage, setServiceImage] = useState('');
  const [serviceValue, setServiceValue] = useState(1);

  const getServices = (type_id = null) => {
    //let url = 'http://localhost:8800/api/services/getTypeServices';
    console.log("API URL:", process.env.REACT_APP_API_URL);
    let url = `${process.env.REACT_APP_API_URL}/services/getTypeServices`;
    console.log("url services: "+url);
    if (type_id !== null) {
      url += `?type_id=${type_id}`;
    }
    axios.get(url)
      .then(response => {
        setServices(response.data);
        // Actualizar la imagen del servicio según el tipo seleccionado       
      })
      .catch(error => {
        console.error(error);
      });
  }

  useEffect(() => {
    getServices();
  }, []);

  // Función para actualizar la imagen del servicio según la categoría seleccionada
  const updateServiceImage = (category) => {
    switch (category) {
      case 'Maquillaje':
        setServiceImage('https://firebasestorage.googleapis.com/v0/b/noi-donostia-16e2f.appspot.com/o/Servicios%2FMaquillaje%2Fmaquillaje1.jpg?alt=media&token=3828a65e-3e43-45fd-bf37-56cdbb6bf6aa');
        break;
      case 'Manicuras':
        setServiceImage('https://firebasestorage.googleapis.com/v0/b/noi-donostia-16e2f.appspot.com/o/Servicios%2FManicura%2Fmanicura9.jpg?alt=media&token=f83a85bc-7d7c-4a72-a268-ec596d0db17c');
        break;
      case 'Pedicuras':
        setServiceImage('https://firebasestorage.googleapis.com/v0/b/noi-donostia-16e2f.appspot.com/o/Servicios%2FPedicura%2Fpedicura2.jpg?alt=media&token=3d1abd7b-c413-4456-b565-688947775125');
        break;
      case 'Tratamientos de pelo':
        setServiceImage('https://firebasestorage.googleapis.com/v0/b/noi-donostia-16e2f.appspot.com/o/Servicios%2FCabello%2Fpeinado1.jpg?alt=media&token=59dea373-a0a0-4b40-82ba-5c93d9a4eafa');
        break;
      default:
        setServiceImage('');
        break;
    }
  };

  useEffect(() => {
    updateServiceImage(selectedCategory);
  }, [selectedCategory]);


  const ServicesList = () => {
    return (
      <div className="services-list">
        <ul className="service-list">
              {services.map((service) => (
                <li key={service.id} className="service-list-item-li">
                  <div className="service-list-item">
                    <div className="service-title">
                      <h3 className="service-name">{service.name} {service.duration}'</h3>
                      <h3 className="service-price">{service.price}€</h3>
                    </div>
                    <div className="service-description">
                      <p>{service.description}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            <Link to='/booking' className="home-button">
              Pedir cita
            </Link>
      </div>
    );
  };

  const ServiceImage = () => {
    return (
      <div className={`services-image ${selectedCategory}`}>
        {serviceImage && <img src={serviceImage} alt="Servicio" />}
      </div>
);
  };

  // Función para renderizar la lista de servicios según la categoría seleccionada
  const renderServices = () => {

    const isAll = (serviceValue === 1);
    const isPair = (serviceValue % 2 === 0);
    console.log(isPair);

    return (
      <div className="services-main">
        <h2>{selectedCategory}</h2>
        <div className="services">
          {isAll ? (
            <ServicesList />
          ) : (
            <>
              {isPair ? (
                <>
                  <ServicesList />
                  <ServiceImage />
                </>
              ) : (
                <>
                  <ServiceImage />
                  <ServicesList />
                </>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="services-container">
      <div className="services-header">
        <h1>Nuestros Servicios</h1>
        
          <p>
            {/* Bienvenido a NOI, donde la belleza se convierte en arte y la elegancia se refleja en cada detalle de tus uñas. En nuestro exclusivo espacio de estética,
          te invitamos a experimentar un cuidado personalizado que realza la belleza natural de tus manos y pies. En NOI, nos enorgullece ofrecer servicios de estética de
          alta calidad, combinando la pasión por la belleza con técnicas avanzadas y productos premium. Embárcate en un viaje de indulgencia y estilo con nosotros.
          ¡Tus uñas merecen lo mejor!
          */}
          <br />Pide tu cita y descubre NOI en el arte de la estética!</p>
      </div>
      <div className="category-buttons">
        <button value="1" onClick={() => { setSelectedCategory('Todos los servicios'); getServices(); setServiceValue(1); }} className={selectedCategory === 'Todos' ? 'selected' : ''}>Todos los servicios</button>
        <button value="2" onClick={() => { setSelectedCategory('Manicuras'); getServices(1); setServiceValue(2);}} className={selectedCategory === 'Manicuras' ? 'selected' : ''}>Manicuras</button>
        <button value="3" onClick={() => { setSelectedCategory('Pedicuras'); getServices(2); setServiceValue(3);}} className={selectedCategory === 'Pedicuras' ? 'selected' : ''}>Pedicuras</button>
        <button value="4" onClick={() => { setSelectedCategory('Tratamientos de pelo'); getServices(4); setServiceValue(4);}} className={selectedCategory === 'Tratamientos de pelo' ? 'selected' : ''}>Tratamientos de pelo</button>
        <button value="5" onClick={() => { setSelectedCategory('Maquillaje'); getServices(3); setServiceValue(5);}} className={selectedCategory === 'Maquillaje' ? 'selected' : ''}>Maquillaje</button>
      </div>
      {renderServices()}
    </div>
  );
};

export default Services;
